import { Injectable } from '@angular/core';
import { BookingServiceBase } from '@shared/booking-feature';
import { Observable } from 'rxjs';
import { BsFreeSlotsRequestDto } from '../interface/dto/self-booking/bs-freeslots-request-dto';
import { TimeSlotDto } from '../interface/dto/self-booking/time-slot-dto';

@Injectable({
    providedIn: 'root',
})
export class SelfBookingServiceClientService extends BookingServiceBase {
    getFreeSlots(bsId: number, allowanceToken: string, data: BsFreeSlotsRequestDto): Observable<TimeSlotDto[]>;
    getFreeSlots(maskedBsId: string, maskedContractorId: string, data: BsFreeSlotsRequestDto): Observable<TimeSlotDto[]>;
    getFreeSlots(
        bsIdOrMaskedBsId: number | string,
        allowanceTokenOrMaskedContractorId: string,
        data: BsFreeSlotsRequestDto,
    ): Observable<TimeSlotDto[]> {
        return this.post(`${this.PatientApiBaseUrl}/freeslots/bs/${bsIdOrMaskedBsId}/token/${allowanceTokenOrMaskedContractorId}`, data, {
            ...this.AuthBypassOptions,
        });
    }
}
